import React from 'react';
import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';

import PrivateRoute from './utils/PrivateRoute'
import { AuthProvider } from './context/AuthContext';

import { BrowserRouter as Router, Routes,  Route } from 'react-router-dom';
import Home from './pages/Home';
// import Page2 from './pages/Page2';
import Auth from './pages/Auth';
import Selection from './pages/Selection';
import ActivitiesHome from './pages/ActivitiesHome';
import InnovatorsHome from './pages/InnovatorsHome';
// import InnovatorForm from './pages/InnovatorForm';
import SnackPage from './pages/SnackPage';
import InnovatorPhone from './pages/InnovatorPhone';
import MediaUploadPage from './pages/MediaUploadPage';
import FullInnovatorForm from './pages/FullInnovatorForm';
import CheckPhoneForMediaUpload from './pages/CheckPhoneForMediaUpload';
import Page404 from './pages/Page404';
import ScoutingReportForm from './pages/ScoutingReportForm';
// import ScoutingSubmissionPage from './pages/Hey';
import SelectScoutingReportType from './pages/SelectScoutingReportType';
import UploadScoutingMedia from './pages/UploadScoutingMedia';
import ScoutingMediaList from './pages/ScoutingMediaList';
import MySubmissions from './pages/MySubmissions';
import VolunteersPerformance from './pages/VolunteersPerformance';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>

  <React.StrictMode>
    {/* <App /> */}
    <AuthProvider>

      <Routes>  

            {/* Private Routes */}
                <Route element={<PrivateRoute />}>
                  <Route path='/innovator-phone' element={<InnovatorPhone/>} />
              {/* <Route path='/innovator-form' element={<InnovatorForm/>} /> */}
                  <Route path='/' element={<Selection/>} />  
                  <Route path='/full-innovator-form' element={<FullInnovatorForm/>} />
                  <Route path='/add-innovator-multimedia' element={<MediaUploadPage/>} />
                  <Route path='/check-phone-for-media-upload' element={<CheckPhoneForMediaUpload />} />
                  <Route path='/scouting-report-form' element={<ScoutingReportForm />} />
                  <Route path='/scouting-media-list' element={<ScoutingMediaList />} />
                  <Route path='/upload-scouting-media/:report_id' element={<UploadScoutingMedia />} />
                  <Route path='/select-scouting-report-type' element={<SelectScoutingReportType />} />
                  <Route path='/innovator-phone' element={<InnovatorPhone/>} />
                  <Route path='/my-submissions' element={<MySubmissions/>} />
                  
                
                </Route>  

            {/* <Route path='/' element={<Home />} /> */}
            <Route path='/login' element={<Auth />} />  

              
            
            <Route path='/innovators-home' element={<InnovatorsHome/>} />  
            <Route path='/activities-home' element={<ActivitiesHome/>} /> 
            <Route path='/snack' element={<SnackPage/>} /> 

            <Route path='/volunteer-performance' element={<VolunteersPerformance/>} />


            <Route path="*" element={<Page404 />} />
            {/* <Route path='/innovator-form' element={<InnovatorForm/>} /> */}
            {/* <Route path='/full-innovator-form' element={<FullInnovatorForm/>} /> */}
            
      </Routes> 
    </AuthProvider>
  </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
